const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.mrgiq.com';
const API_BASE_URL_PHONEXA = process.env.REACT_APP_API_URL_PHONEXA || 'https://api.whoffers.com';

export const API_ENDPOINTS = {
  BASE_URL: API_BASE_URL,
  LOGIN: `${API_BASE_URL}/api/login`,
  STATS: `${API_BASE_URL}/api/stats`,
  SITES: `${API_BASE_URL}/api/sites`,
  SWEEPS_DETAILS: `${API_BASE_URL}/api/sweeps-details`,
  CLIENTS: `${API_BASE_URL_PHONEXA}/api/clients`,
  CLIENT_DETAILS: (id: string) => `${API_BASE_URL_PHONEXA}/api/clients/${id}`,
  PROJECT_DETAILS: (id: string) => `${API_BASE_URL}/api/details/${id}`,
  SUBDOMAINS: (id: string) => `${API_BASE_URL}/api/domains/${id}/subdomains`,
  SUBDOMAIN_DETAILS: `${API_BASE_URL}/api/subdomain/details`,
  LEADS: `${API_BASE_URL_PHONEXA}/api/phonexa-leads`,
  LEADS_EXPORT: `${API_BASE_URL_PHONEXA}/api/phonexa-leads/export`,
  LEAD_DETAILS: (id: string) => `${API_BASE_URL_PHONEXA}/api/leads/phonexa/${id}`,
  LEADS_DISPOSITION_UPLOAD: `${API_BASE_URL_PHONEXA}/api/leads/disposition/upload`,
  REPORT_MRG_IQ_PERFORMANCE: `${API_BASE_URL_PHONEXA}/api/reports/mrg-iq-performance`,
  VENDORS: `${API_BASE_URL_PHONEXA}/api/vendors`,
  VENDOR_DETAILS: (id: string) => `${API_BASE_URL_PHONEXA}/api/vendors/${id}`,
  CAMPAIGNS: `${API_BASE_URL_PHONEXA}/api/campaigns`,
  CAMPAIGN_DETAILS: (id: string) => `${API_BASE_URL_PHONEXA}/api/campaigns/${id}`,
  VERTICALS: `${API_BASE_URL_PHONEXA}/api/verticals`,
  VERTICAL_DETAILS: (id: string) => `${API_BASE_URL_PHONEXA}/api/verticals/${id}`,
  VERTICAL_CLIENTS: (id: string) => `${API_BASE_URL_PHONEXA}/api/verticals/${id}/clients`,
  VERTICAL_SUBVERTICALS: (id: string) => `${API_BASE_URL_PHONEXA}/api/verticals/${id}/subverticals`,
  VERTICAL_SUBVERTICAL_DETAILS: (verticalId: string, name: string) =>
    `${API_BASE_URL_PHONEXA}/api/verticals/${verticalId}/subverticals/${encodeURIComponent(name)}`,
  VERTICAL_ZIP_CODES: (id: string, page: number = 1, perPage: number = 50) =>
    `${API_BASE_URL_PHONEXA}/api/verticals/${id}/zip-codes?page=${page}&per_page=${perPage}`,
  VERTICAL_ZIP_CODES_UPLOAD: (id: string) =>
    `${API_BASE_URL_PHONEXA}/api/verticals/${id}/zip-codes`,
  SIMPLISAFE_CLICKS: `${API_BASE_URL}/api/simplisafe-clicks`,
  PARTNERS: `${API_BASE_URL_PHONEXA}/api/partners`,
  PARTNER_DETAILS: (id: string | number) =>
    `${API_BASE_URL_PHONEXA}/api/partners/${id}`,
};

export default API_ENDPOINTS;

